{{#if tls}}
	<button type="button" on-click="@this.togglePopover()" class="btn gp-tls-details {{#unless tls.authorized}}tls-error{{/unless}}" aria-label="TLS Details" title="{{tls.protocol}} - {{tls.cipherName}}" data-content="{{@this.getTlsString(tls)}}" data-html="true" data-container=".c-gp-results-raw-output">
		<i class="fa {{#if tls.authorized}}fa-lock{{else}}fa-unlock-alt{{/if}}" aria-hidden="true"></i> TLS
	</button>
{{/if}}

<script>
	const _ = require('../../assets/js/_');

	component.exports = {
		data () {
			return {
				_,
			};
		},
		computed: {
			placement () {
				return this.get('screenWidth') >= 1200 ? 'right' : 'top';
			},
			template () {
				return `<div class="popover ${this.get('tls.authorized') ? '' : 'popover-danger'}" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>`;
			},
		},
		onrender () {
			if (!Ractive.isServer) {
				this.observe('placement', (newValue, oldValue) => {
					if (oldValue) {
						$(this.find('button')).popover('destroy');
					}

					clearTimeout(this.popoverInitTimeout);

					this.popoverInitTimeout = setTimeout(() => {
						this.popoverInitTimeout = null;
						let button = this.find('button');

						let closeHandler = (e) => {
							if (e.target !== button && $(e.target).closest('.popover').length === 0) {
								button.click();
							}
						};

						let unbind = () => {
							$(document).off('click', closeHandler);
							$(document).off('resize', closeHandler);
							$('.c-gp-results-raw-output_list').off('scroll', closeHandler);
						};

						$(button).on('show.bs.popover', () => {
							$(document).on('click', closeHandler);
							$(document).on('resize', closeHandler);
							$('.c-gp-results-raw-output_list').on('scroll', closeHandler);
						}).on('hide.bs.popover', unbind);

						this.on('unrender', unbind);
					}, 600);
				}, { defer: true });
			}
		},
		onunrender () {
			clearTimeout(this.popoverInitTimeout);
			this.popoverInitTimeout = null;
		},
		ondetach () {
			if (!Ractive.isServer) {
				$(this.find('button')).popover('destroy');
			}
		},
		togglePopover () {
			$(this.find('button')).popover({ placement: this.get('placement'), template: this.get('template') }).popover('toggle');
		},
		getTlsString (tls) {
			let esc = value => this.get('@shared.escape')(String(value ?? ''));
			let subject = tls.subject || {};
			let issuer = tls.issuer || {};

			return `
				<table class="table tls-table" style="margin-bottom: 0; overflow-wrap: anywhere;">
					${tls.authorized ? '' : `<tr style="color: #eb3333;">
						<th>Error</th>
						<td>${esc(tls.error)}</td>
					</tr>`}
					<tr>
						<th style="min-width: 86px;">Subject</th>
						<td>${esc(subject.CN)}; ${esc(subject.alt)}</td>
					</tr>
					<tr>
						<th>Issuer</th>
						<td>${esc(issuer.CN)}; ${esc(issuer.O)}; ${esc(issuer.C)}</td>
					</tr>
					<tr>
						<th>Validity</th>
						<td>${_.formatDateTime(tls.createdAt)}; ${_.formatDateTime(tls.expiresAt)}</td>
					</tr>
					<tr>
						<th>Serial number</th>
						<td>${esc(tls.serialNumber)}</td>
					</tr>
					<tr>
						<th>Fingerprint</th>
						<td>${esc(tls.fingerprint256)}</td>
					</tr>
					<tr>
						<th>Key type</th>
						<td>${esc(tls.keyType)}${esc(tls.keyBits)}</td>
					</tr>
				</table>
			`;
		},
	};
</script>
